module.exports = __webpack_public_path__ + "img/barcode.f188cd49.svg";